// removed by extract-text-webpack-plugin
module.exports = {"dialog":"OptInTermsDialogTheme__dialog___1KFo_","title":"OptInTermsDialogTheme__title___2U_L3 DialogTheme__title___3R5SE","body":"OptInTermsDialogTheme__body___8RAtU DialogTheme__body___2MUm9"};


//////////////////
// WEBPACK FOOTER
// ./src/options/components/OptInTermsDialogTheme.css
// module id = 763
// module chunks = 0